import * as React from "react"
import { Facet } from "./Facet"
import { DocumentAttributeKeys } from "../../constants"
import { attributeValueToString } from "../utils"
import _ from "lodash"

export class DataSourceFacet extends React.Component {
  dataSourceIdToName = (value) => {
    const { dataSourceNameLookup } = this.props

    if (!dataSourceNameLookup || !value) {
      return ""
    } else {
      return _.get(dataSourceNameLookup, attributeValueToString(value), "")
    }
  }

  render() {
    const {
      dataSourceNameLookup,
      disableAdd,
      facetConfiguration,
      valueCountPairs,
      onSelectionChange,
      onClear,
      selectedFacets,
    } = this.props

    if (!dataSourceNameLookup) {
      // Don't show data source facet if can't translate id to name
      return null
    }

    return (
      <Facet
        attributeName={DocumentAttributeKeys.DataSourceId}
        values={valueCountPairs.map((value) => ({
          ...value,
          ValueLabel: this.dataSourceIdToName(value.DocumentAttributeValue),
        }))}
        disableAdd={disableAdd}
        facetConfiguration={facetConfiguration}
        onSelectionChange={onSelectionChange}
        onClear={onClear}
        selectedFacets={selectedFacets}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/facets/components/DataSourceFacet.js